import React from "react"
import { Button, Modal } from "react-bootstrap"

const ModalComponent = ({
  modalsize,
  animationFade,
  modeltitle,
  modalheaderclass,
  bodyclass,
  children,
  footerclass,
  btnclosetext,
  closebtnvariant,
  submitname,
  onHide,
  handleSubmit,
  formbuttonid,
  loading,
  ...modalProps
}) => {
  return (
    <>
      <Modal
        {...modalProps}
        onHide={onHide}
        size={modalsize || "lg"}
        animation={animationFade || false}
        centered
      >
        {modeltitle ? (
          <Modal.Header closeButton>
            <Modal.Title className={modalheaderclass}>
              {modeltitle || "Default Modal Title"}
            </Modal.Title>
          </Modal.Header>
        ) : (
          ""
        )}
        <Modal.Body className={bodyclass}>{children}</Modal.Body>
        {submitname || btnclosetext ? (
          <Modal.Footer className={footerclass}>
            {btnclosetext ? (
              <Button
                variant={closebtnvariant || "light"}
                onClick={onHide}
              >
                {btnclosetext || "Close"}
              </Button>
            ) : (
              ""
            )}

            {submitname ? (
              <Button
                variant={closebtnvariant || "primary"}
                type="submit"
                onClick={handleSubmit}
                form={formbuttonid}
                disabled={loading}
              >
                {submitname || "Save"}
              </Button>
            ) : (
              ""
            )}
          </Modal.Footer>
        ) : (
          ""
        )}
      </Modal>
    </>
  )
}

export default ModalComponent
